var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNellKnifeEdge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.62845 45.5571L8.62817 45.5571C8.61074 45.5571 8.59348 45.5536 8.57736 45.547L1.91482 42.8087C1.33109 42.5688 0.950001 42.0001 0.950001 41.369C0.950001 40.748 1.31921 40.1863 1.88937 39.9401L8.57529 37.0524L8.58464 37.0484L8.59482 37.0483L24.5904 36.9554C25.0615 36.9527 25.3769 37.439 25.1822 37.868C25.145 37.9499 25.1287 38.0397 25.1346 38.1294L25.5645 44.6495C25.5682 44.7063 25.587 44.761 25.619 44.808C25.8077 45.0852 25.6105 45.4607 25.2751 45.4626L8.62845 45.5571Z",
    fill: "#343333",
    stroke: "#343333",
    strokeWidth: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 41H25",
    stroke: "white",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3391 45.5571H71.3393C71.3567 45.5571 71.374 45.5536 71.3901 45.547L78.0526 42.8087C78.6364 42.5688 79.0175 42.0001 79.0175 41.369C79.0175 40.748 78.6483 40.1863 78.0781 39.9401L71.3922 37.0524L71.3828 37.0484L71.3726 37.0483L54.6449 36.9676C54.0612 36.9648 53.9555 37.7983 54.5214 37.9413C54.706 37.9879 54.8309 38.1597 54.8183 38.3496L54.4125 44.5061C54.4045 44.6268 54.3159 44.727 54.197 44.7496C53.7621 44.8323 53.8209 45.4724 54.2636 45.4745L71.3391 45.5571Z",
    fill: "#343333",
    stroke: "#343333",
    strokeWidth: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4675 41L54.9675 41",
    stroke: "white",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4463 40.1619C24.4463 48.5493 31.3182 55.3633 39.7525 55.3901V55.4066H39.8025C48.2762 55.4066 55.1587 48.5822 55.1587 40.1783C55.1587 31.7744 48.2762 24.95 39.8025 24.95C31.3289 24.95 24.4463 31.7579 24.4463 40.1619ZM25.3563 40.1783C25.3563 32.2729 31.8295 25.8532 39.8025 25.8532C47.759 25.8532 54.2488 32.273 54.2488 40.1783C54.2488 48.0837 47.7755 54.5034 39.8025 54.5034C31.8295 54.5034 25.3563 48.0837 25.3563 40.1783Z",
    fill: "#343333",
    stroke: "#343333",
    strokeWidth: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0507 29.9994H29.5543V50.3245H50.0507V29.9994Z",
    stroke: "#343333",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7878 25.7905L25.2947 40.1626L39.7878 54.5346L54.281 40.1626L39.7878 25.7905Z",
    stroke: "#343333",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNellKnifeEdge);
export default __webpack_public_path__ + "static/media/NellKnifeEdge.3514cc1c4bff545086a47a184adbb10c.svg";
export { ForwardRef as ReactComponent };